import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAuth from './store/auth/auth.reducer';
import * as fromUi from './store/ui/ui.reducer';
import * as fromNotifications from './store/notifications/notifications.reducer';
import * as fromCart from './store/cart/cart.reducer';

export interface State {
  auth: fromAuth.State;
  ui: fromUi.State;
  notifications: fromNotifications.State;
  cart: fromCart.State;
}

export const reducers: ActionReducerMap<State> = {
  auth: fromAuth.authReducer,
  ui: fromUi.uiReducer,
  notifications: fromNotifications.notificationsReducer,
  cart: fromCart.cartReducer
};

// Auth
export const getAuthState = createFeatureSelector<fromAuth.State>('auth');
export const getIsLoggedIn = createSelector(getAuthState, fromAuth.getIsLoggedIn);
export const getIdentity = createSelector(getAuthState, fromAuth.getIdentity);

// UI
export const getUiState = createFeatureSelector<fromUi.State>('ui');
export const getSidenavIsOpened = createSelector(getUiState, fromUi.getSidenavIsOpened);

// Notifications
export const getNotificationsState = createFeatureSelector<fromNotifications.State>('notifications');
export const getNotifications = createSelector(getNotificationsState, fromNotifications.getNotifications);
export const getNotificationsLimit = createSelector(getNotificationsState, fromNotifications.getNotificationsLimit);
export const getUnreadNotifications = createSelector(getNotificationsState, fromNotifications.getUnreadNotifications);
export const getNotificationsInfiniteDisabled = createSelector(getNotificationsState, fromNotifications.getInfiniteDisabled);

// Cart
export const getCartState = createFeatureSelector<fromCart.State>('cart');
export const getCartSize = createSelector(getCartState, fromCart.getCartSize);
